var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthicallyMade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "50px",
    viewBox: "0 0 51 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ethically Made") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ethically-Made",
    transform: "translate(0.958214, 0.909650)",
    stroke: "#111111",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6068353,48.0903498 L35.6068353,40.5427943 L49.0417856,27.107844 C49.0417856,24.4300119 49.0417856,20.0470005 49.0417856,13.95881 C49.0417856,4.82652431 35.6068353,-6.25545984 24.5417856,4.82652431 C13.5512583,-6.52603978 -0.341381588,4.47610741 0.116308004,13.95881 C-0.0387693346,17.1982868 -0.0387693346,21.5812982 0.116308004,27.107844 L13.5512583,40.5427943 L13.5512583,48.0903498",
    id: "Path-25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(28.771786, 13.958810)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,34.1315398 L0,19.8255473 L8.226,11.5995473 C9.83999694,10.5696188 11.460965,10.5696188 13.0889042,11.5995473",
    id: "Path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5444521,18.8227891 L15.7357014,9.63153976 L15.7357014,3.55663225 C16.4581634,1.18554408 17.9695963,0 20.27,0",
    id: "Path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.906786, 31.024580) scale(-1, 1) translate(-10.906786, -31.024580) translate(0.771786, 13.958810)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,34.1315398 L0,19.8255473 L8.226,11.5995473 C9.83999694,10.5696188 11.460965,10.5696188 13.0889042,11.5995473",
    id: "Path-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5444521,18.8227891 L15.7357014,9.63153976 L15.7357014,3.55663225 C16.4581634,1.18554408 17.9695963,0 20.27,0",
    id: "Path-27"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-28",
    points: "21.0417856 40.759093 25.0417856 44.759093 29.0417856 40.759093"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthicallyMade);
export default __webpack_public_path__ + "static/media/ethicallyMade.0bae210c5ecad927128ec86dfc71bbf4.svg";
export { ForwardRef as ReactComponent };